import {
  Tooltip as AriaTooltip,
  TooltipTrigger as AriaTooltipTrigger,
  Button,
  OverlayArrow,
  type TooltipProps,
} from 'react-aria-components';
import customIcons from '../utils/icons';

export const TooltipVariant = {
  Default: 'default',
  Grey: 'grey',
} as const;

export type TooltipVariantValue = typeof TooltipVariant[keyof typeof TooltipVariant];

const variantStyles: Record<TooltipVariantValue, {
  icon: string,
  bubble: string,
  text?: string,
  placement?: TooltipProps['placement'],
  offset?: TooltipProps['offset'],
  crossOffset?: TooltipProps['crossOffset'],
}> = {
  [TooltipVariant.Default]: {
    icon: 'bg-transparent text-primary cursor-pointer',
    bubble: 'tooltip',
    text: 'text-sm',
  },
  [TooltipVariant.Grey]: {
    icon: 'flex items-center justify-center size-6 bg-transparent text-base text-piptext-default cursor-pointer',
    bubble: 'tooltip-grey',
    placement: 'bottom start',
    offset: 10,
    crossOffset: -8, // keeps the arrow clear of the bubble's rounded corner
  },
};

export default function Tooltip({ label, text, variant = TooltipVariant.Default }: Readonly<{
  label: string,
  text: string,
  variant?: TooltipVariantValue,
}>) {
  const styles = variantStyles[variant];

  return (
    (
      <AriaTooltipTrigger delay={0} closeDelay={0}>
        <Button aria-label={label} className={styles.icon}>
          {customIcons.infoIcon}
        </Button>
        <AriaTooltip
          className={styles.bubble}
          placement={styles.placement}
          offset={styles.offset}
          crossOffset={styles.crossOffset}
        >
          {variant === TooltipVariant.Grey && (
            <OverlayArrow>
              <svg
                aria-hidden="true"
                width={24}
                height={9}
                viewBox="0 0 24 9"
                className="fill-pipbg-subtle in-data-[placement=bottom]:rotate-180"
              >
                <path d="M0 0 L12 9 L24 0" />
              </svg>
            </OverlayArrow>
          )}
          <span className={styles.text}>{text}</span>
        </AriaTooltip>
      </AriaTooltipTrigger>
    )
  );
}
